(function(){
  'use strict';
  var PAW_FIT_LOG_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwHNse1Q0mK-Lro_tR1PKzGl9iZO-4jKbkRu62v6izGJ1xucehdDNnHwGwYOUhX1J7y/exec';

  var sessionLogged = {};
  window.pawLogFit = function(payload){
    try {
      if(!PAW_FIT_LOG_ENDPOINT) return;
      var key = [payload.source,payload.year,payload.make,payload.model,payload.sub].join('|');
      if(sessionLogged[key]) return;
      sessionLogged[key] = true;
      payload.page = location.pathname + location.search;

      // ---- NEW: Meta FitCheck event (browser pixel + data for CAPI) ----
      // Own try/catch so the sheet logging below can never be affected.
      // If the snippet isn't loaded or the visitor opted out, payload.meta
      // is simply left off and the sheet ignores it either way.
      try {
        if (window.PAWMeta) {
          var meta = window.PAWMeta.fitCheck({
            year: payload.year,
            make: payload.make,
            model: payload.model,
            submodel: payload.sub,
            result: payload.result,
            sizes: payload.fits,
            floorType: payload.legSetup
          });
          if (meta) {
            meta.custom_data.lookup_source = payload.source || '';
            payload.meta = meta;
          }
        }
      } catch(metaErr){}
      // ---- END NEW ----

      fetch(PAW_FIT_LOG_ENDPOINT, {
        method:'POST', mode:'no-cors',
        headers:{'Content-Type':'text/plain;charset=utf-8'},
        body: JSON.stringify(payload), keepalive:true
      }).catch(function(){});
    } catch(e){}
  };
})();